import { Staff } from '@/@types/staff';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface IStaffsTableProps {
  data: Staff[];
  columns: ColumnDefinitionType<Staff>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof Staff;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
  fillAvailableHeight?: boolean;
}

export function StaffsTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
  fillAvailableHeight = false,
}: IStaffsTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
      fillAvailableHeight={fillAvailableHeight}
    />
  );
}
